import { render, staticRenderFns } from "./AsignatureSearch.vue?vue&type=template&id=4fb9e2f4&scoped=true"
import script from "./AsignatureSearch.vue?vue&type=script&lang=js"
export * from "./AsignatureSearch.vue?vue&type=script&lang=js"
import style0 from "./AsignatureSearch.vue?vue&type=style&index=0&id=4fb9e2f4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9e2f4",
  null
  
)

export default component.exports